import {toast} from 'react-toastify';

const Grade = ({
  questions,
  handleAnswers,
  setIsOpenGrade,
  handleGradeAnswer,
  answers,
}: IGradeProps) => {
  return (
    <>
      {questions.map((item, index) => (
        <div key={index}>
          <p className=" text-primary text-sm my-2">
            {index + 1}: {item.title}
          </p>
          {item.answers.map((answer, index) => (
            <div className="flex text-sm my-1" key={index}>
              <label>
                <input
                  type="radio"
                  className="mx-2"
                  name={item.title}
                  onChange={() =>
                    handleAnswers({
                      name: item.guid,
                      guid: answer.guid,
                    })
                  }
                />
                {answer.title}
              </label>
            </div>
          ))}
        </div>
      ))}
      <button
        className=" py-4 bg-primary rounded-md text-white text-center w-full my-3"
        onClick={() => {
          if (answers.length > 0) {
            setIsOpenGrade(false);
            handleGradeAnswer();
          } else {
            toast.error('لطفا به سوالات پاسخ دهید');
          }
        }}
      >
        تعیین سطح
      </button>
    </>
  );
};

export default Grade;
